import React from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';

function MainComponent({ menu, Component }) {
    const param = useParams();
    const id = param?.id;

    return (
        <>
            <div className="content-heading">
                {menu.name} {id && '>'} {id}
            </div>
            <Component />
        </>
    );
}

MainComponent.propTypes = {
    menu: PropTypes.object.isRequired,
    Component: PropTypes.func.isRequired,
};

export default MainComponent;
